module.exports = __webpack_public_path__ + "static/media/ADMINISTRACIONDINERO7_22 (29).785376b.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videos/ADMINISTRACIONDINERO7_22 (29).mp4
// module id = 804
// module chunks = 1